<template>
  <div class="ClaimFlow">
    <div class="main">
        <p class="title2">商户通过WiFi万能钥匙分享WiFi后，因黑客篡改WiFi密码、劫持商户收银、盗刷商户账户内资金等恶意行为，导致商户在银行账户内的资产，及商户在合法运营的第三方支付机构所设本商户实名账户中的资产遭受损失，应立即采取以下措施：</p>
        <p class="label"><span class="circle"></span>1.证据保全</p>
        <p class="text">商户在使用WiFi万能钥匙分享热点后，发现账户资金遭受损失的，应立即采取相关证据保全措施，不应自行刷机、清理交易设备缓存、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与交易对方的聊天记录及所下载的软件，以免导致相关证据无法保全；</p>
        <p class="label"><span class="circle"></span>2.报案</p>
        <p class="text">商户在使用WiFi万能钥匙分享热点后，发现账户资金遭受损失的，应立即拨打保险公司电话进行报案，并应于10个自然日内前往具有管辖权的公安机关进行报案，并取得案件受理通知书等相关证明材料；</p>
        <p class="text highlight">众安保险客服电话:400-999-9595</p>
        <p class="text highlight">(7×24小时统一客服热线)</p>
        <p class="label"><span class="circle"></span>3.准备索赔资料</p>
        <p class="text">商户应自账户资金遭受经济损失之日起15个自然日内根据WiFi万能钥匙客户端索赔界面的提示准备索赔资料，并听从工作人员的操作指导，积极配合工作人员的工作，并配合提供相关损失证明文件，以便有效追查被盗情况并保全证据；</p>
        <p class="text">若保险公司或WiFi万能钥匙的工作人员联系用户时，首次尝试联系商户起72小时内仍无法与商户取得联系的，或商户不履行本协议约定的配合义务的，将视商户自动放弃索赔。</p>
        <p class="label"><span class="circle"></span>4.提交索赔资料</p>
        <p class="text">商户应根据保险公司工作人员的指示提交索赔资料，并确保其所提交的资料的真实性，否则，本公司及保险公司有权拒绝受理或赔付商户的索赔申请；商户知悉并了解，该等资料中的相关信息包括但不限于商户身份证号码、银行卡号、手机号码、详细住址等个人信息，商户在此同意并授权本公司及保险公司为实现本协议项下的索赔目的对商户的该等个人信息予以采集和使用；</p>
        <p>商户应通过线下快递方式递交如下索赔资料（不接受快递到付）：</p>
        <p class="text highlight">
          收件人：WiFi万能钥匙商户安全理赔项目组<br>
          快递联系电话：400-035-8000<br>
          寄送地址：上海市浦东新区张衡路666弄1号楼7楼
        </p>
        <p class="label"><span class="circle"></span>5.理赔结果</p>
        <p class="text last">保险公司根据商户提交的材料将认定最终理赔结果，如最终确认属于理赔责任范围内的情形，由保险公司向商户指定的个人收款账户支付赔款，最终理赔额在人民币3000元（含3000元）以下的案件由保险公司在确认最终理赔结果后的5个工作日之内支付赔款；最终理赔额在人民币3000元以上的案件由保险公司在确认最终理赔结果后的10个工作日之内支付赔款。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'newclaimFlow',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style scoped>
html { font-family: "Microsoft Yahei",arial,helvetica,sans-serif; -webkit-text-size-adjust:none; word-break : break-word;}
html, body, div, span, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, a, code, em, img, q, small, strong, dd, dl, dt, li, ol, ul, fieldset, form, label, table, tbody, tr, th, td, input { margin: 0; padding: 0; outline:0;}

body{background-color: #f3f3f3;height: 100%;}
a[href$="1257113351"]{width: 0;height:0;position: absolute;top: -1000px;left:-1000px;}
.hide{display: none;}
.f12{font-size: 12px;}
.f14{font-size: 14px;}
.c3{color: #333;}
.fb{font-weight: bold;}
.t_c{text-align: center;}

.main{display: block; position: relative;color: #666666;padding:0 6% 36px 6%;}
.title{font-size: 16px; color: #0285f0;  line-height: 20px}
.title2{font-size: 12px; color: #666666; font-weight: bold;  line-height: 20px;margin:16px 0; }
.title_bold{font-size: 12px; color: #333333; font-weight: bold;  line-height: 22px;}
.label{font-size: 12px;color:#333333;font-weight: bold;}
.notes{margin-top: 17px;margin-bottom: 2px;}
.text{font-size: 12px;color: #666666;line-height: 24px; margin-bottom: 3px;}
.highlight{color: #0285f0;}
.label{line-height: 25px;}
p {line-height: 20px;}
.text{line-height: 20px;padding-bottom: 10px;}
.label,.text{border-left: #cccccc 1px dotted;  padding-left: 24px;}
.last{border:none;}
.circle {
    display: block;
    width: 8px;
    height: 8px;
    background: #0285f0;
    -moz-border-radius: 4px;
    -webkit-border-radius: 4px;
    border-radius: 4px;
    position: absolute;
    left: 5%;
    margin-top: 9px;
}
</style>



// WEBPACK FOOTER //
// claimFlow.vue?251af42e